export const CONSUMPTION_ROLES = 'CONSUMPTION_ROLES';

export type AttributeFilter = Partial<Record<string, string>>;
